var enLang = {
	"Được phép nâng giá bán tối đa": "Max raised price allowed",
	"Giá muốn bán không được vượt quá {{var0}}": "Selling price cannot exceed {{var0}}",
	"Giá muốn bán không được nhỏ hơn giá sản phẩm": "Selling price cannot be less than supplier price",
	"Giá sản phẩm": "Supplier price",
	"Giá muốn bán": "Selling price",
	"Nhập số tiền": "Input amount",
	"Số tiền chênh:": "Gap amount:",
	"Sửa giá": "Edit price",
	"Dùng sau": "Use later",
	"Áp dụng": "Apply",
	"Bỏ chọn": "Unselect",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Bạn chỉ có thể mua tối đa {{maximumValue}} sản phẩm": "You can only purchase max {{maximumValue}} products",
	"Chú ý": "Note",
	"Bạn muốn xoá sản phẩm này ra khỏi giỏ hàng?": "Are your sure to delete product from Cart?",
	"Đồng ý": "Agree",
	"Hủy bỏ": "Cancel",
	"Xóa": "Delete",
	"x{{ProductVoucherQuantity}} Voucher dùng cho đơn hàng sau": "x{{ProductVoucherQuantity}} Voucher used for next order",
	"Không bán chịu": "Not selling on credit",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Chỉ áp dụng trên một số sản phẩm": "Applicable for some specific products only",
	"Giảm": "Discount",
	"tối đa {{maxAmount}}": "max {{maxAmount}}",
	"Dành": "Applicable",
	"cho đơn hàng từ {{min}} đến {{max}}": "for the order from {{min}} to {{max}}",
	"cho đơn hàng tối thiểu {{min}}": "for the order from {{min}}",
	"cho đơn hàng dưới {{max}}": "for the order under {{max}}",
	"cho tất cả các đơn hàng": "for all orders",
	"Giảm {{percent}}% tối đa {{maxAmount}}": "{{percent}}% off up to {{maxAmount}}",
	"{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau": "{{quantity}}x {{name}} Discount code for next order",
	"Thành tiền": "Total",
	"Đơn giá": "Unit price",
	"Số lượng": "Quantity",
	"Khuyến mại hot": "Promotions hot",
	"HSD:": "Expiry date:",
	"Chương trình khuyến mại": "Promotions",
	"Sản phẩm ưu đãi": "Promotional products",
	"Tìm kiếm chương trình khuyến mại": "Search promotions",
	"Xem thêm": "Show more",
	"Rút gọn": "Collapse",
	"Tìm kiếm sản phẩm khuyến mại": "Search promotional products",
	"Không tìm thấy chương trình nào.": "No program found.",
	"Không tìm thấy sản phẩm nào.": "No product found.",
	"Lỗi": "Error"
};

export { enLang as default };
